import { TenantEntity } from '../TenantEntity'

export class Flight extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'Flight'
  }
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  get atd() {
    return this._data.atd
  }
  set atd(atd) {
    this._data.atd = atd
  }
  get ata() {
    return this._data.ata
  }
  set ata(ata) {
    this._data.ata = ata
  }
  get handOffDateTime() {
    return this._data.handOffDateTime
  }
  set handOffDateTime(handOffDateTime) {
    this._data.handOffDateTime = handOffDateTime
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get departureTime() {
    return this._data.departureTime
  }
  set departureTime(departureTime) {
    this._data.departureTime = departureTime
  }
  get settleState() {
    return this._data.settleState
  }
  set settleState(settleState) {
    this._data.settleState = settleState
  }
  get flightDescriptionUuid() {
    return this._data.flightDescriptionUuid
  }
  set flightDescriptionUuid(flightDescriptionUuid) {
    this._data.flightDescriptionUuid = flightDescriptionUuid
  }
}
